import { render, staticRenderFns } from "./component-order-detaile-certificate-verification.vue?vue&type=template&id=20e0a3f9&"
import script from "./component-order-detaile-certificate-verification.vue?vue&type=script&lang=js&"
export * from "./component-order-detaile-certificate-verification.vue?vue&type=script&lang=js&"
import style0 from "./component-order-detaile-certificate-verification.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports